import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { linkTeamsAccount } from '../api/teamsLink'

type Status = 'ready' | 'working' | 'done' | 'error'

// The link the Regen bot sends in Teams to someone it could not match to a
// Regen user. Opening it only shows this page: Teams and other apps open links
// on their own to make previews, so the button is what links the account.
export function TeamsLinkPage() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [status, setStatus] = useState<Status>(token ? 'ready' : 'error')
  const [message, setMessage] = useState(token ? '' : 'This link is missing its token. Ask the Regen bot in Teams for a new one.')

  const confirm = async () => {
    setStatus('working')
    try {
      await linkTeamsAccount(token)
      setStatus('done')
    } catch (err) {
      setMessage(err instanceof Error && err.message ? err.message : 'Could not link your Teams account. Ask the Regen bot in Teams for a new link.')
      setStatus('error')
    }
  }

  return (
    <div className="mx-auto max-w-md p-6">
      <h1 className="text-lg font-semibold text-text-primary">Connect your Teams account</h1>
      {status === 'done' ? (
        <p className="mt-3 text-sm text-text-secondary">
          Done. Regen can now page you in Microsoft Teams. You can close this page.
        </p>
      ) : (
        <>
          <p className="mt-3 text-sm text-text-secondary">
            This connects the Teams account that asked for this link to the Regen account you are signed in to now.
            Only continue if you asked the Regen bot for it.
          </p>
          {status === 'error' && message && <p className="mt-3 text-sm text-red-600">{message}</p>}
          {status !== 'error' || token ? (
            <button
              type="button"
              onClick={confirm}
              disabled={status === 'working' || !token}
              className="mt-4 rounded-md bg-accent px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
            >
              {status === 'working' ? 'Connecting...' : 'Connect my Teams account'}
            </button>
          ) : null}
        </>
      )}
    </div>
  )
}
